/**
 * `components.MuiBackdrop` — scrim color and optional `backdropFilter` blur (`blurEffect` / `invisible`).
 * Discoverability: `MuiBackdrop`, `Backdrop`, `Modal`, `Dialog`, `blurEffect`.
 *
 * @see https://mui.com/material-ui/api/backdrop/
 *
 */
import type { Components, Theme } from '@mui/material/styles';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import store from 'app-components/utils/redux-store';

export function muiBackdrop(theme: Theme): Pick<Components<Theme>, 'MuiBackdrop'> {
  let dev = false;
  try {
    // protect unit tests from breaking
    dev = Boolean(store && featureFlagsSelectors.getFeatureFlag(store.getState(), 'dev'));
  } catch (e) {
    verify(false, e);
  }

  return {
    MuiBackdrop: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          backgroundColor: theme.palette.backdrop.light,
          // Default to true if blurEffect is not specified
          ...(ownerState.blurEffect !== false &&
            !dev && {
              backdropFilter: theme.palette.blur.soft,
            }),
        }),
        invisible: {
          backgroundColor: 'transparent',
          backdropFilter: 'none',
        },
      },
    },
  };
}
